import { render } from "./SourceForm.vue?vue&type=template&id=8051b804"
import script from "./js/sourceForm.js?vue&type=script&lang=js&external"
export * from "./js/sourceForm.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__